<template>
  <AppSelect
    v-model="acquiry"
    :label="$tt('extra_nationality.how')"
    :items="toSelectItems(ACQUIRIES)"
    :rules="[required]"
  />
</template>

<script setup lang="ts">
import { toSelectItems } from '~/helpers/general';
import type { NationalityAcquiredBy } from '~/types';

const { tt } = useLocalization();
const { required } = useValidation();

const ACQUIRIES: Record<NationalityAcquiredBy, string> = {
  birth: tt('extra_nationality.birth'),
  parents: tt('extra_nationality.parents'),
  naturalization: tt('extra_nationality.naturalization')
};

const acquiry = defineModel<NationalityAcquiredBy>({ required: true });
</script>